import {Text, View} from "@react-pdf/renderer";
import React, {useContext} from "react";

import { baseStyles } from "../styles";
import {PDFContext} from "../BasePDF";

export const TradeInformationPDF = () => {
    const pdfData = useContext(PDFContext)
    if (!pdfData) return null;

    return (
        <View style={{...baseStyles.marginRight, ...baseStyles.table}}>
            <View style={{...baseStyles.tableHeader, backgroundColor: pdfData.pageColor}}>
                <Text>Trade Information</Text>
            </View>

            <View>
                <View style={baseStyles.flexBetween}>
                    <Text style={baseStyles.flex}>
                        Gross Trade (Allowance)
                    </Text>
                    <Text>{pdfData.gross_trade.toDollarFormat()}</Text>
                </View>

                <View style={baseStyles.flexBetween}>
                    <Text>
                        Owed Trade (Payoff)
                    </Text>
                    <Text>{pdfData.owed_trade.toDollarFormat()}</Text>
                </View>

                <View style={{...baseStyles.flexBetween, ...baseStyles.boldTopBorder}}>
                    <Text>
                        Trade Equity (Applied)
                    </Text>
                    <Text>{pdfData.trade_equity.toDollarFormat()}</Text>
                </View>
            </View>
        </View>
    )
}